import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  lowerDivider: {
    marginTop: 9,
  },
  searchResultsText: {
    fontSize: 14,
    minHeight: "unset",
  },
  resetButton: {
    paddingTop: 4,
    paddingBottom: 4,
    fontSize: 14,
  },
  resultsTextAndChips: {
    minWidth: "90%",
  },
  resetContainer: {
    alignContent: "flex-start",
    justifyContent: "flex-end",
    width: "10%",
  },
});

export default useStyles;
